module.exports = __webpack_public_path__ + "assets/offline-pay.fbdc0309.svg";